import { render, staticRenderFns } from "./user-parkings.vue?vue&type=template&id=4f0c783d"
import script from "./user-parkings.vue?vue&type=script&lang=js"
export * from "./user-parkings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports